import React, { useState, useEffect } from 'react';

import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CardBody } from 'react-bootstrap';
import { generateAppropriateDate } from '../../basic-component/DateUtils';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import { skeleton_animation_style_primary } from '../../../../constants/constants';
import { removeHTMLElementsAndTruncateText } from '../../basic-component/CommonUtils';
const Historytimeline = (data) => {
  const data1 = data.data;
  console.log(data);
  const [description,setDescription]=useState();
  const [organizationName, setOrganizationName] = useState("");
  const { t } = useTranslation();
  const [mailList, setMailList] = useState([]);
  useEffect(() => {
    console.log(data?.data?.serviceMailList);
    setMailList(data?.data?.serviceMailList);
    setDescription(data?.data?.feedbackDetails?.description)
  }, [data]);
  const extractMessage = (html) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.textContent || tempElement.innerText || '';
  };
  const handleClick = (item) => {
    console.log(item);
    data.mailOpen(item);
  }

  return (
    <>
      <div className='section history-info'>
        <h5 className='card-title mb-3'>{t('general.label.history')}</h5>
        {description ? (<ul class="timeline">
          {(mailList)?.map((item, index) => (
            <li class="timeline-item" onClick={() => handleClick(item.id)}>
              <div class="timeline-body">
                <div class="timeline-content">
                  <Card className="border-0">
                    <CardBody className="p-0">
                      <h6 className='fw-normal'>
                        <i className="ti ti-mail-forward me-2"></i>
                        <span className='fw-medium'>{t('general.label.to')}</span>
                        <span className='mail-id'>:  {item.mailToStr && item.mailToStr.includes(',') ? item.mailToStr.substring(0, item.mailToStr.indexOf(',')) : item.mailToStr}

                        </span>
                      </h6>
                      <h6 className='fw-normal mb-2 fs-7'>{item.subject ? removeHTMLElementsAndTruncateText(item.subject, 100) : ''}</h6>
                      <p className='text-secondary fs-7'>{generateAppropriateDate(item.lastAttemptDate)}</p>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </li>
          ))}
          {description ? (<li class="timeline-item">
            <div class="timeline-body">
              <div class="timeline-content">
                <Card className="border-0">
                  <CardBody className="p-0">
                    <h6 className='fw-normal'>
                      <i className="ti ti-user me-2"></i>
                      {/* <span className='fw-medium'>To: </span> */}
                      <span className='mail-id'>{t('feedbackDetails.feedbackDescription.text')}</span>
                    </h6>
                    <h6 className='fw-normal mb-2 fs-7'>{removeHTMLElementsAndTruncateText(extractMessage(data?.data?.feedbackDetails?.description?.substring(0)), 50)}
                    </h6>
                    {/* <p className='text-secondary fs-7'>December 10, 2023 at 11:30a.m</p> */}
                  </CardBody>
                </Card>
              </div>
            </div>
          </li>) : ("")}
        </ul>) : (
          <Row className='g-2'>
            <Col lg="auto">
              <Skeleton animation={skeleton_animation_style_primary} variant="circular" width={20} height={20} className='' />
            </Col>
            <Col>
              <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={20} className='mb-1' />
            </Col>
            <div className='clearfix'></div>
            <Col lg="auto">
              <Skeleton animation={skeleton_animation_style_primary} variant="circular" width={20} height={20} className='' />
            </Col>
            <Col>
              <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={20} className='mb-1' />
            </Col>
            <div className='clearfix'></div>
            <Col lg="auto">
              <Skeleton animation={skeleton_animation_style_primary} variant="circular" width={20} height={20} className='' />
            </Col>
            <Col>
              <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={20} className='mb-1' />
            </Col>
            <div className='clearfix'></div>
            <Col lg="auto">
              <Skeleton animation={skeleton_animation_style_primary} variant="circular" width={20} height={20} className='' />
            </Col>
            <Col>
              <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={20} className='mb-1' />
            </Col>
          </Row>
        )}
      </div>

    </>
  );
}
export default Historytimeline;